<template>
	<div>
		<crud v-bind="$attrs"></crud>
		<import-edocuments-report-dialog :report="$route.query.import_report" @close="closeReport"></import-edocuments-report-dialog>
	</div>
</template>

<script>
	import Crud from '@/components/common/Crud'
	import ImportEdocumentsReportDialog from '@/components/modules/invoices/edocuments/ImportEdocumentsReportDialog'

	/** Elenco documenti ricevuti con il resoconto dell'import massivo aperto dalla notifica. */
	export default {
		name: 'edocuments-index',
		components: { Crud, ImportEdocumentsReportDialog },
		inheritAttrs: false,
		methods: {
			closeReport() {
				const query = Object.assign({}, this.$route.query)
				delete query.import_report
				this.$router.replace({ path: this.$route.path, query }).catch(() => {})
			},
		},
	}
</script>
